import * as idb from 'idb';
import * as untils from '../../utils/tree';


function findTaskById(tasks, id) {
    for (const task of tasks) {
        if (task.id === id) {
            return task;
        }
        if (task.children) {
            const foundTask = findTaskById(task.children, id);
            if (foundTask) {
                return foundTask;
            }
        }
    }
    return null; // Task not found
}
export async function openIndexedDB() {
    if (!('indexedDB' in window)) {
        console.log("This browser doesn't support IndexedDB");
        return;
    }

    try {
        const dbName = 'global-tasks';
        const dbVersion = 1;

        const indexDb = await idb.openDB(dbName, dbVersion, {
            upgrade(db) {
                console.log('Creating a new object store...');

                // Checks if the object store exists:
                if (!db.objectStoreNames.contains('global-tasks-data')) {
                    // If the object store does not exist, create it:
                    db.createObjectStore('global-tasks-data');
                }
            }
        });

        return indexDb;

    } catch (error) {
        console.error("Error opening IndexedDB:", error);
    }
}
export async function storeTaskList(taskList) {

    console.log("Calling Store Task List");

    const db = await openIndexedDB();
    const tx = db.transaction('global-tasks-data', 'readwrite');
    const store = tx.objectStore('global-tasks-data');

    const tasksKey = "taskList"; // Replace with your chosen key

    await store.put(taskList, tasksKey);

    await tx.complete;
}
export async function storeCommands(commands) {
    console.log("Calling Store Command List");
    const db = await openIndexedDB();
    const tx = db.transaction('global-tasks-data', 'readwrite');
    const store = tx.objectStore('global-tasks-data');

    const commandsKey = "commands"; // Replace with your chosen key

    await store.put(commands, commandsKey);

    await tx.complete;
}
export async function storeUser(user) {
    console.log("Calling Store User Info");
    const db = await openIndexedDB();
    const tx = db.transaction('global-tasks-data', 'readwrite');
    const store = tx.objectStore('global-tasks-data');

    const userKey = "user"; // Replace with your chosen key

    await store.put(user, userKey);

    await tx.complete;
}
export async function getTasks() {
    const db = await openIndexedDB(); // Open the database
    if (!db) return null; // Error handling if database opening fails

    try {
        const tx = db.transaction('global-tasks-data', 'readonly'); // Read-only transaction
        const tasksStore = tx.objectStore('global-tasks-data');

        const tasks = await tasksStore.get('taskList'); // Retrieve data using key

        await tx.complete; // Commit the transaction

        return tasks; // Return the retrieved task list data (or null if not found)
    } catch (error) {
        console.error("Error retrieving tasks from IndexedDB:", error);
    }

}
export async function removeTask(taskId) {
    const db = await openIndexedDB();
    if (!db) return null; 
    try {
        const tx = db.transaction('global-tasks-data', 'readwrite'); // Read-only transaction
        const tasksStore = tx.objectStore('global-tasks-data');

        const tasks = await tasksStore.get('taskList'); // Retrieve data using key // Get all tasks (assuming ID is a property within each task object)

        const filteredTasks = tasks.filter(task => task.id !== taskId); // Filter out the task with the matching ID

        await tasksStore.clear(); // Clear the existing data (optional: consider performance if large)
        await tasksStore.put(filteredTasks, 'taskList'); // Store the filtered tasks back with the same key

        tasksStore.delete(taskId)

        await tx.complete;
    } catch (error) {
        console.error("Error retrieving tasks from IndexedDB:", error);
    }
}
export async function updateTask(updatedTask, taskId) {
    const db = await openIndexedDB();
    if (!db) return null;

    try {
        const tx = db.transaction('global-tasks-data', 'readwrite');
        const store = tx.objectStore('global-tasks-data');

        // Retrieve the current task list
        const tasks = await store.get('taskList');

        // Find the index of the task to update based on ID
        const taskIndex = tasks.findIndex(task => task.id === taskId);

        // Check if task exists
        if (taskIndex !== -1) {
            // Update the task at the found index with the new data
            tasks[taskIndex] = updatedTask;

            // Store the updated task list back under the same key
            await store.put(tasks, 'taskList');
        } else {
            console.warn(`Task with ID ${taskId} not found for update`);
        }

        await tx.complete;
    } catch (error) {
        console.error("Error updating task in IndexedDB:", error);
    }
}
export async function updateTaskComment(taskId, commentId, newCommentText) {
    const db = await openIndexedDB();
    if (!db) return null;

    try {
        const tx = db.transaction('global-tasks-data', 'readwrite');
        const store = tx.objectStore('global-tasks-data');

        // Retrieve the task list
        const tasks = await store.get('taskList');

        // Find the task to update
        const taskToUpdate = findTaskById(tasks, taskId);

        if (!taskToUpdate) {
            console.error(`Task with ID ${taskId} not found`);
            return;
        }

        // Find the comment to update
        const commentIndex = taskToUpdate.comments.findIndex(comment => comment.id === commentId);

        if (commentIndex !== -1) {
            taskToUpdate.comments[commentIndex].text = newCommentText;

            // Save the updated task list
            await store.put(tasks, 'taskList');
        } else {
            console.error(`Comment with ID ${commentId} not found in task ${taskId}`);
        }

        await tx.complete;
    } catch (error) {
        console.error("Error updating task comment:", error);
    }
}
export async function updateTaskColor(taskId, newColor) {
    const db = await openIndexedDB();
    if (!db) return null;

    try {
        const tx = db.transaction('global-tasks-data', 'readwrite');
        const store = tx.objectStore('global-tasks-data');

        // Retrieve the task list
        const tasks = await store.get('taskList');

        // Find the task to update
        const taskToUpdate = findByIdInTreeList(tasks, taskId);

        if (!taskToUpdate) {
            console.error(`Task with ID ${taskId} not found`);
            return;
        }

        taskToUpdate.color = newColor;

        // Save the updated task list
        await store.put(tasks, 'taskList');

        await tx.complete;
    } catch (error) {
        console.error("Error updating task color:", error);
    }
}
export async function updateTaskSiblingOrder(taskId, newOrder) {
    const db = await openIndexedDB();
    if (!db) return null;

    try {
        const tx = db.transaction('global-tasks-data', 'readwrite');
        const store = tx.objectStore('global-tasks-data');

        // Retrieve the task list
        const tasks = await store.get('taskList');

        // Find the task to update
        const taskToUpdate = findTaskById(tasks, taskId);

        if (!taskToUpdate) {
            console.error(`Task with ID ${taskId} not found`);
            return;
        }

        taskToUpdate.siblingOrder = newOrder;

        // Save the updated task list
        await store.put(tasks, 'taskList');

        await tx.complete;
    } catch (error) {
        console.error("Error updating task sibling order:", error);
    }
}
export async function updateTaskType(taskId, newType) {
    const db = await openIndexedDB();
    if (!db) return null;

    try {
        const tx = db.transaction('global-tasks-data', 'readwrite');
        const store = tx.objectStore('global-tasks-data');

        // Retrieve the task list
        const tasks = await store.get('taskList');

        // Find the task to update
        const taskToUpdate = findTaskById(tasks, taskId);

        if (!taskToUpdate) {
            console.error(`Task with ID ${taskId} not found`);
            return;
        }

        taskToUpdate.color = newColor;

        // Save the updated task list
        await store.put(tasks, 'taskList');

        await tx.complete;
    } catch (error) {
        console.error("Error updating task type:", error);
    }
}

export async function deleteTask(taskId) {
    const db = await openIndexedDB();
    if (!db) return null;

    try {
        const tx = db.transaction('global-tasks-data', 'readwrite');
        const store = tx.objectStore('global-tasks-data');

        // Retrieve the task list
        const tasks = await store.get('taskList');

        // Use findTaskById to locate the task (including children)
        const taskToDelete = findTaskById(tasks, taskId);

        if (taskToDelete) {
            // Remove the task from the parent or from the top level if it's a top-level task
            const parentTaskIndex = tasks.findIndex(task => task.children && task.children.includes(taskToDelete));
            if (parentTaskIndex !== -1) {
                tasks[parentTaskIndex].children.splice(tasks[parentTaskIndex].children.indexOf(taskToDelete), 1);
            } else {
                tasks.splice(tasks.indexOf(taskToDelete), 1);
            }

            // Save the updated task list
            await store.put(tasks, 'taskList');
        } else {
            console.error(`Task with ID ${taskId} not found`);
        }

        await tx.complete;
    } catch (error) {
        console.error("Error deleting task:", error);
    }
}
export async function deleteTaskComment(taskId, commentId) {
    const db = await openIndexedDB();
    if (!db) return null;

    try {
        const tx = db.transaction('global-tasks-data', 'readwrite');
        const store = tx.objectStore('global-tasks-data');

        // Retrieve the task list
        const tasks = await store.get('taskList');

        // Find the task to update
        const taskToUpdate = findTaskById(tasks, taskId);

        if (!taskToUpdate) {
            console.error(`Task with ID ${taskId} not found`);
            return;
        }

        // Find the index of the comment to delete
        const commentIndex = taskToUpdate.comments.findIndex(comment => comment.id === commentId);

        if (commentIndex !== -1) {
            taskToUpdate.comments.splice(commentIndex, 1); // Remove the comment

            // Save the updated task list
            await store.put(tasks, 'taskList');
        } else {
            console.error(`Comment with ID ${commentId} not found in task ${taskId}`);
        }

        await tx.complete;
    } catch (error) {
        console.error("Error deleting task comment:", error);
    }
}

export async function addCommentToTask(taskId, commentText) {
    const db = await openIndexedDB();
    if (!db) return null;

    try {
        const tx = db.transaction('global-tasks-data', 'readwrite');
        const store = tx.objectStore('global-tasks-data');

        // Retrieve the task list
        const tasks = await store.get('taskList');

        // Find the task to update
        const taskToUpdate = findTaskById(tasks, taskId);

        if (!taskToUpdate) {
            console.error(`Task with ID ${taskId} not found`);
            return;
        }

        // Create a new comment object
        const newComment = {
            //id: Date.now(), // Or generate a unique ID
            text: commentText
        };

        // Add the new comment to the task's comments array
        taskToUpdate.comments.push(newComment);

        // Save the updated task list
        await store.put(tasks, 'taskList');

        await tx.complete;
    } catch (error) {
        console.error("Error adding comment to task:", error);
    }
}




